<template>
    <footer class="flex w-full items-center justify-center mt-[50px] z-50 bg-gray-800">
        <div class="container lg:max-w-[1200px] h-full relative px-[20px] w-full flex flex-col items-center justify-between">
            <div class="w-full bg-white rounded-[20px] my-[50px] p-[20px] flex flex-wrap items-center justify-between">
                <div>
                  <p class="text-[#D4AF37] text-[14px]">Pour se tenir au courant des offres</p>
                  <h2 class="text-gray-800 font-bold text-[20px]">Rejoignez la communauté MOH.IMMO</h2>
                </div>

                <div class="lg:w-[45%] w-full relative">
                  <form @submit.prevent="handleSubscribe" class="relative">
                    <input 
                      v-model="email" 
                      type="email" 
                      placeholder="Entrez votre adresse e-mail" 
                      required
                      class="w-full h-[50px] rounded-[10px] px-[20px] pr-[120px] py-[30px] border-[1px] border-gray-300 focus:outline-none focus:border-[#D4AF37] duration-200" 
                    />
                    <button 
                      type="submit"
                      :disabled="isLoading"
                      class="absolute right-[10px] top-[10px] p-[10px] px-[15px] rounded-[5px] text-white font-bold text-sm bg-[#D4AF37] hover:bg-[#c9a42e] duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <span v-if="!isLoading">S'inscrire</span>
                      <span v-else class="flex items-center justify-center">
                        <svg class="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Envoi...
                      </span>
                    </button>
                  </form>
              
                  <!-- Messages d'état -->
                  <div v-if="message" class="mt-3 transition-all duration-300" :class="{
                    'text-green-600': messageType === 'success',
                    'text-red-600': messageType === 'error'
                  }">
                    <div class="flex items-start">
                      <svg v-if="messageType === 'success'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                      </svg>
                      <svg v-if="messageType === 'error'" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                      </svg>
                      <span>{{ message }}</span>
                    </div>
                  </div>
                </div>
            </div>
            <div class="flex w-full flex-wrap items-start justify-start mb-[25px] lg:gap-10 md:gap-[30px]">
                <div class="lg:w-[calc(100%/4-30px)] md:w-[calc(100%/2-15px)] w-full">
                    <p class="text-gray-100 font-semibold">MOH.IMMO, votre partenaire de confiance pour des logements sûrs, accessibles et adaptés à vos besoins.</p>
                    <div class="flex items-center justify-start gap-5 mt-[40px] mb-[20px] md:mb-0">
                        <a target="_blanck" href="https://www.facebook.com/share/18YdCiwzA1/?mibextid=wwXIfr" class="w-[30px] h-[30px] rounded-[50%] bg-[#D4AF37] text-gray-800 font-bold text-center flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><!-- Icon from Material Line Icons by Vjacheslav Trushkin - https://github.com/cyberalien/line-md/blob/master/license.txt --><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="4"><path stroke-dasharray="24" stroke-dashoffset="24" d="M17 4l-2 0c-2.5 0 -4 1.5 -4 4v12"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.4s" values="24;0"/></path><path stroke-dasharray="8" stroke-dashoffset="8" d="M8 12h7"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.5s" dur="0.2s" values="8;0"/></path></g></svg>
                        </a>
                        <a target="_blanck" href="https://www.instagram.com/moh.immo/profilecard/?igsh=MWM5cXByNXI3bzgzYQ==" class="w-[30px] h-[30px] rounded-[50%] bg-[#D4AF37] text-gray-800 font-bold text-center flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><!-- Icon from Material Line Icons by Vjacheslav Trushkin - https://github.com/cyberalien/line-md/blob/master/license.txt --><circle cx="17" cy="7" r="1.5" fill="currentColor" fill-opacity="0"><animate fill="freeze" attributeName="fill-opacity" begin="1.3s" dur="0.15s" values="0;1"/></circle><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path stroke-dasharray="72" stroke-dashoffset="72" d="M16 3c2.76 0 5 2.24 5 5v8c0 2.76 -2.24 5 -5 5h-8c-2.76 0 -5 -2.24 -5 -5v-8c0 -2.76 2.24 -5 5 -5h4Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="72;0"/></path><path stroke-dasharray="28" stroke-dashoffset="28" d="M12 8c2.21 0 4 1.79 4 4c0 2.21 -1.79 4 -4 4c-2.21 0 -4 -1.79 -4 -4c0 -2.21 1.79 -4 4 -4"><animate fill="freeze" attributeName="stroke-dashoffset" begin="0.7s" dur="0.6s" values="28;0"/></path></g></svg>
                        </a>
                        <a target="_blanck" href="https://www.tiktok.com/@moh.immo?_t=ZM-8wn8tfX8O1g&_r=1" class="w-[30px] h-[30px] rounded-[50%] bg-[#D4AF37] text-gray-800 font-bold text-center flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE --><path fill="currentColor" d="M16.6 5.82s.51.5 0 0A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5c-1.42 0-2.6-1.16-2.6-2.6c0-1.72 1.66-3.01 3.37-2.48V9.66c-3.45-.46-6.47 2.22-6.47 5.64c0 3.33 2.76 5.7 5.69 5.7c3.14 0 5.69-2.55 5.69-5.7V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3s-1.88.09-3.24-1.48"/></svg>
                        </a>
                    </div>
                </div>
                <div class="lg:w-[calc(100%/4-30px)] md:w-[calc(100%/2-15px)] w-full">
                    <h2 class="text-white font-bold text-[20px]">Nos Biens Immobiliers</h2>
                    <ul class="text-gray-100 text-[14px]">
                        <li class="my-[10px] cursor-pointer duration-200 list-disc ml-[20px]">Appartements meublés</li>
                        <li class="my-[10px] cursor-pointer duration-200 list-disc ml-[20px]">Chambres simples</li>
                        <li class="my-[10px] cursor-pointer duration-200 list-disc ml-[20px]">Studios</li>
                        <li class="my-[10px] cursor-pointer duration-200 list-disc ml-[20px]">Villas</li>
                    </ul>
                </div>
                <div class="lg:w-[calc(100%/4-30px)] md:w-[calc(100%/2-15px)] w-full">
                    <h2 class="text-white font-bold text-[20px]">Liens Utiles</h2>
                    <ul class="text-gray-100 text-[14px]">
                        <li @click="goToHomePage()" class="my-[10px] cursor-pointer hover:text-[#D4AF37] list-disc ml-[20px] hover:underline duration-200">Accueil</li>
                        <li @click="goToAboutPage()" class="my-[10px] cursor-pointer hover:text-[#D4AF37] list-disc ml-[20px] hover:underline duration-200">À propos de Nous</li>
                        <li @click="goToReservationPage()" class="my-[10px] cursor-pointer hover:text-[#D4AF37] list-disc ml-[20px] hover:underline duration-200">Réserver un Bien</li>
                        <li @click="goToContactPage()" class="my-[10px] cursor-pointer hover:text-[#D4AF37] list-disc ml-[20px] hover:underline duration-200">FAQ</li>
                    </ul>
                </div>
                <div class="lg:w-[calc(100%/4-30px)] md:w-[calc(100%/2-15px)] w-full">
                    <h2 class="text-white font-bold text-[20px]">Contact</h2>
                    <ul class="text-gray-100">
                        <span class="my-[10px] cursor-pointer text-[#D4AF37] flex items-center flex-wrap">
                            <svg class="mr-[10px]" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><!-- Icon from Myna UI Icons by Praveen Juge - https://github.com/praveenjuge/mynaui-icons/blob/main/LICENSE --><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.6 14.522c-2.395 2.52-8.504-3.534-6.1-6.064c1.468-1.545-.19-3.31-1.108-4.609c-1.723-2.435-5.504.927-5.39 3.066c.363 6.746 7.66 14.74 14.726 14.042c2.21-.218 4.75-4.21 2.215-5.669c-1.268-.73-3.009-2.17-4.343-.767"/></svg>
                            +(229)
                            <a target="_blanck" href="tel:+2290190179456" class="ml-[5px] hover:underline duration-200"> 0190179456</a> / 
                            <a target="_blanck" href="tel:+2290156581203" class="ml-[5px] hover:underline duration-200"> 0156581203</a>
                        </span>
                        <a target="_blanck" href="mailto:support@mohimmo.com" class="my-[10px] cursor-pointer text-[#D4AF37] flex items-center hover:underline duration-200">
                            <svg class="mr-[10px]" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><!-- Icon from Huge Icons by Hugeicons - undefined --><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="currentColor"><path d="m7 8.5l2.942 1.74c1.715 1.014 2.4 1.014 4.116 0L17 8.5"/><path d="M2.016 13.476c.065 3.065.098 4.598 1.229 5.733c1.131 1.136 2.705 1.175 5.854 1.254c1.94.05 3.862.05 5.802 0c3.149-.079 4.723-.118 5.854-1.254c1.131-1.135 1.164-2.668 1.23-5.733c.02-.986.02-1.966 0-2.952c-.066-3.065-.099-4.598-1.23-5.733c-1.131-1.136-2.705-1.175-5.854-1.254a115 115 0 0 0-5.802 0c-3.149.079-4.723.118-5.854 1.254c-1.131 1.135-1.164 2.668-1.23 5.733a69 69 0 0 0 0 2.952"/></g></svg>
                            support@mohimmo.com</a>
                        <li class="my-[10px] cursor-pointer text-[#D4AF37] flex items-center hover:underline duration-200">
                            <svg class="mr-[10px]" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE --><path fill="currentColor" d="M12 19.35q3.05-2.8 4.525-5.087T18 10.2q0-2.725-1.737-4.462T12 4T7.738 5.738T6 10.2q0 1.775 1.475 4.063T12 19.35m0 1.975q-.35 0-.7-.125t-.625-.375Q9.05 19.325 7.8 17.9t-2.087-2.762t-1.275-2.575T4 10.2q0-3.75 2.413-5.975T12 2t5.588 2.225T20 10.2q0 1.125-.437 2.363t-1.275 2.575T16.2 17.9t-2.875 2.925q-.275.25-.625.375t-.7.125M12 12q.825 0 1.413-.587T14 10t-.587-1.412T12 8t-1.412.588T10 10t.588 1.413T12 12"/></svg>
                            Cotonou, Bénin</li>
                    </ul>
                </div>
            </div>
            <div class="w-full border-t-[0.25px] border-[#D4AF37] py-[25px] flex items-center justify-between">
                <div class="w-full flex items-center justify-between lg:flex-row flex-col">
                    <p class="text-gray-100 text-[14px] mb-[15px] lg:text-left text-center">© 2025 MOH.IMMO. Tous droits réservés. Développé par <a href="https://vaybe.tech" target="_blank" class="text-sm font-bold text-white hover:underline duration-200">Vaybe</a></p>
                    <div class="flex items-center justify-center md:gap-5 gap-[15px] md:flex-row flex-col">
                        <p class="text-gray-100 text-[14px] cursor-pointer hover:text-[#D4AF37] duration-200">Politique de Confidentialité</p>
                        <p class="text-gray-100 text-[14px] cursor-pointer hover:text-[#D4AF37] duration-200">Conditions d'Utilisation</p>
                        <p class="text-gray-100 text-[14px] cursor-pointer hover:text-[#D4AF37] duration-200">Mentions Légales</p>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import apiClient from '@/services/api'

const router = useRouter();

const email = ref('');
const message = ref('');
const messageType = ref('');
const isLoading = ref(false);

const handleSubscribe = async () => {
  isLoading.value = true;
  message.value = '';
  messageType.value = '';

  try {
    const response = await apiClient.post('/subscriptions/subscribe', { email: email.value })

    const data = await response.json();

    if (response.status == 200 || response.status == 201) {
      messageType.value = 'success';
      message.value = 'Merci pour votre inscription !';
      email.value = '';
    } else {
      messageType.value = 'error';
      message.value = data.message || "Une erreur s'est produite";
    }
  } catch (err) {
    messageType.value = 'error';
    message.value = "Erreur de connexion au serveur";
    console.error(err);
  } finally {
    isLoading.value = false;
    
    // Effacer le message après 5 secondes
    if (message.value) {
      setTimeout(() => {
        message.value = '';
        messageType.value = '';
      }, 5000);
    }
  }
};


function goToHomePage() {
    router.push('/');
}
function goToContactPage() {
    router.push('/contact');
}
function goToReservationPage() {
    router.push('/reservation');
}
function goToAboutPage() {
    router.push('/about');
}
function goToLoginPage() {
    router.push('/login');
}
function goToDashboardPage() {
    router.push('/dashboard');
}
</script>

<style>

</style>